document.addEventListener('DOMContentLoaded', () => {
  const carousel = document.getElementById('ProductMediaCarousel')
  const track = document.getElementById('ProductMediaTrack')
  const dotsContainer = document.getElementById('ProductMediaDots')
  const prevBtn = carousel ? carousel.querySelector('.pdp-carousel__arrow--prev') : null
  const nextBtn = carousel ? carousel.querySelector('.pdp-carousel__arrow--next') : null
  const jsonEl = document.getElementById('ProductMediaJSON')
  if (!carousel || !track || !jsonEl) return
  const thumbsList = document.getElementById('ProductMediaThumbs')
  const zoomBtn = carousel.querySelector('.pdp-carousel__zoom')
  const stage = carousel.querySelector('.pdp-carousel__stage')

  let allMedia = []
  let photoswipeInstance = null

  // Full-screen viewer: open showing the whole image, then click / double-tap
  // toggles between that and one zoomed-in level, with no third state.
  const viewerOptions = {
    scaleMode: 'fit',
    closeOnVerticalDrag: false,
    // A click on the slide background (the bands beside a fitted image) must not
    // close the viewer; it closes only via the close control or Escape.
    closeElClasses: [],
    getDoubleTapZoom: function (isMouseClick, item) {
      const initial = item.initialZoomLevel || 1
      const gallery = photoswipeInstance ? photoswipeInstance.gallery : null
      const current = gallery ? gallery.getZoomLevel() : initial
      // Already zoomed (by click, tap or pinch): returning the current level makes
      // the viewer's click toggle go back to the whole image.
      if (isMouseClick && current > initial + 0.001) return current
      let target = Math.min(1, initial * 3)
      if (target < initial * 1.5) target = initial * 2
      return target
    }
  }
  // A mouse click on the slide background (outside the image itself) runs the
  // same zoom toggle as a click on the image. Touch taps are left unchanged, and
  // the toolbar buttons are not slide background so they keep their own handlers.
  document.addEventListener('pswpTap', function (e) {
    const gallery = photoswipeInstance ? photoswipeInstance.gallery : null
    const detail = e.detail
    if (!gallery || !gallery.currItem || !detail || detail.pointerType !== 'mouse') return
    const target = e.target
    if (!target || !target.classList) return
    const isSlideBackground =
      target.classList.contains('pswp__item') ||
      target.classList.contains('pswp__zoom-wrap') ||
      target.classList.contains('pswp__container')
    if (!isSlideBackground) return
    // Same guard PhotoSwipe applies to image clicks: an image too small to zoom stays put
    if (gallery.getZoomLevel() === 1 && gallery.getZoomLevel() <= gallery.currItem.fitRatio) return
    gallery.toggleDesktopZoom(detail.releasePoint)
  })
  // The product section also attaches the stock viewer to this same carousel
  // (it carries data-product-images), so one click opened two viewers on the
  // shared .pswp element and the stock one closed on any background click.
  // Open only this gallery's viewer: handle the click on the stage, before it
  // reaches the carousel-level listeners.
  if (stage && carousel.dataset.zoom !== 'false') {
    stage.addEventListener('click', (e) => {
      const trigger = e.target.closest('.js-photoswipe__zoom')
      if (!trigger || !photoswipeInstance) return
      e.preventDefault()
      e.stopPropagation()
      photoswipeInstance.triggerClick(trigger)
    })
  }
  let renderTimeout = null
  let currentIndex = 0
  let slideCount = 0

  try {
    allMedia = JSON.parse(jsonEl.textContent.trim())
  } catch (e) {
    console.error('Media JSON parse error', e)
  }

  // ────────────────────────────────────────────────
  // Helpers
  // ────────────────────────────────────────────────
  function getSelectedColor() {
    const colorInput = document.querySelector('fieldset[name="color"] input[checked="checked"], fieldset[name="Color"] input[checked="checked"]')
    if (colorInput) return colorInput.value.toLowerCase().replace(/\s+/g, '-')
    if (window.currentVariant && window.currentVariant.option1)
      return window.currentVariant.option1.toLowerCase().replace(/\s+/g, '-')
    return null
  }

  // ────────────────────────────────────────────────
  // Carousel Navigation
  // ────────────────────────────────────────────────
  function goToSlide(target, wrap) {
    let index
    if (target === 'prev') index = currentIndex - 1
    else if (target === 'next') index = currentIndex + 1
    else index = target

    // Arrows wrap around so both are usable on every slide; swipe does not
    if (wrap && slideCount > 1) index = (index + slideCount) % slideCount

    if (isNaN(index) || index < 0 || index >= slideCount) return

    // Pause video on the slide we're leaving
    const prevSlide = track.children[currentIndex]
    if (prevSlide) {
      const video = prevSlide.querySelector('video')
      if (video) video.pause()
    }

    currentIndex = index
    track.style.transform = 'translateX(-' + (currentIndex * 100) + '%)'

    // Update dots
    dotsContainer.querySelectorAll('button').forEach((btn, i) =>
      btn.classList.toggle('active', i === currentIndex)
    )

    syncThumbs()
    syncZoom()
  }

  // ────────────────────────────────────────────────
  // Thumbnail rail (desktop) + zoom button
  // ────────────────────────────────────────────────
  function syncThumbs() {
    if (!thumbsList) return
    const thumbs = thumbsList.children
    for (let i = 0; i < thumbs.length; i++) {
      const isActive = i === currentIndex
      thumbs[i].classList.toggle('is-active', isActive)
      if (isActive) thumbs[i].setAttribute('aria-current', 'true')
      else thumbs[i].removeAttribute('aria-current')
    }

    // Keep the highlighted thumbnail in view without scrolling the page
    const active = thumbs[currentIndex]
    if (!active || thumbsList.clientHeight === 0) return
    const top = active.offsetTop
    const bottom = top + active.offsetHeight
    if (top < thumbsList.scrollTop) {
      thumbsList.scrollTo({ top: top, behavior: 'smooth' })
    } else if (bottom > thumbsList.scrollTop + thumbsList.clientHeight) {
      thumbsList.scrollTo({ top: bottom - thumbsList.clientHeight, behavior: 'smooth' })
    }
  }

  function syncZoom() {
    if (!zoomBtn) return
    const slide = track.children[currentIndex]
    const img = slide ? slide.querySelector('.photoswipe__image') : null
    zoomBtn.hidden = !img
    if (img) zoomBtn.setAttribute('data-index', img.getAttribute('data-index'))
  }

  function buildThumbs(items) {
    if (!thumbsList) return
    thumbsList.replaceChildren()
    carousel.classList.toggle('pdp-carousel--no-thumbs', items.length < 2)
    if (items.length < 2) return
    const labelTemplate = carousel.getAttribute('data-thumb-label') || ''
    items.forEach((m, i) => {
      const btn = document.createElement('button')
      btn.type = 'button'
      btn.className = 'pdp-thumbs__item'
      btn.setAttribute('data-index', i)
      btn.setAttribute('aria-controls', 'ProductMediaTrack')
      btn.setAttribute('aria-label', labelTemplate.replace('[index]', i + 1).replace('[count]', items.length))
      const img = document.createElement('img')
      img.src = (m.src || '').replace(/width=\d+/, 'width=160')
      img.alt = ''
      img.loading = 'lazy'
      img.width = m.width || 1800
      img.height = m.height || 1800
      btn.appendChild(img)
      thumbsList.appendChild(btn)
    })
  }

  if (thumbsList) {
    thumbsList.addEventListener('click', (e) => {
      const thumb = e.target.closest('.pdp-thumbs__item')
      if (!thumb) return
      const index = parseInt(thumb.getAttribute('data-index'), 10)
      if (!isNaN(index)) goToSlide(index)
    })
  }

  // Desktop sizing: the main image is capped to the viewport height left below
  // the gallery's top edge, so the whole image fits without scrolling.
  function setMediaOffset() {
    if (!stage) return
    const top = stage.getBoundingClientRect().top + window.scrollY
    carousel.style.setProperty('--pdp-media-offset', Math.max(0, Math.round(top)) + 'px')
  }

  let resizeTimer
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer)
    resizeTimer = setTimeout(setMediaOffset, 100)
  })
  window.addEventListener('load', setMediaOffset)
  setMediaOffset()

  // ────────────────────────────────────────────────
  // Touch / Swipe
  // ────────────────────────────────────────────────
  let touchStartX = 0
  let touchStartY = 0
  let isSwiping = false

  carousel.addEventListener('touchstart', (e) => {
    touchStartX = e.touches[0].clientX
    touchStartY = e.touches[0].clientY
    isSwiping = true
  }, { passive: true })

  carousel.addEventListener('touchmove', (e) => {
    if (!isSwiping) return
    const diffY = Math.abs(e.touches[0].clientY - touchStartY)
    const diffX = Math.abs(e.touches[0].clientX - touchStartX)
    // If scrolling more vertically, bail out
    if (diffY > diffX) {
      isSwiping = false
    }
  }, { passive: true })

  carousel.addEventListener('touchend', (e) => {
    if (!isSwiping) return
    isSwiping = false
    const diffX = e.changedTouches[0].clientX - touchStartX
    if (Math.abs(diffX) > 50) {
      goToSlide(diffX > 0 ? 'prev' : 'next')
    }
  }, { passive: true })

  // ────────────────────────────────────────────────
  // Arrow Click Handlers
  // ────────────────────────────────────────────────
  if (prevBtn) prevBtn.addEventListener('click', () => goToSlide('prev', true))
  if (nextBtn) nextBtn.addEventListener('click', () => goToSlide('next', true))

  // ────────────────────────────────────────────────
  // Dot Click Handler (event delegation)
  // ────────────────────────────────────────────────
  dotsContainer.addEventListener('click', (e) => {
    const dot = e.target.closest('.pdp-carousel__dot')
    if (!dot) return
    const index = parseInt(dot.getAttribute('data-index'), 10)
    if (!isNaN(index)) goToSlide(index)
  })

  // ────────────────────────────────────────────────
  // Render Media
  // ────────────────────────────────────────────────
  function renderMedia(colorHandle) {
    if (renderTimeout) {
      clearTimeout(renderTimeout)
      renderTimeout = null
    }

    // Close any open PhotoSwipe gallery before updating DOM
    const pswpElement = document.querySelector('.pswp')
    if (pswpElement && pswpElement.classList.contains('pswp--open')) {
      if (photoswipeInstance && photoswipeInstance.gallery) {
        try {
          photoswipeInstance.gallery.close()
          renderTimeout = setTimeout(() => {
            renderTimeout = null
            updateMediaDOM(colorHandle)
          }, 350)
          return
        } catch (e) {
          console.warn('PhotoSwipe close warning:', e)
        }
      }
    }

    updateMediaDOM(colorHandle)
  }

  function updateMediaDOM(colorHandle) {
    // Clear track and dots
    track.replaceChildren()
    dotsContainer.replaceChildren()
    if (thumbsList) thumbsList.replaceChildren()
    currentIndex = 0
    slideCount = 0

    const matching = allMedia.filter(
      m => m.color_group && colorHandle && m.color_group === colorHandle
    )

    let items = []
    if (matching.length > 0) items = matching
    else if (allMedia.length > 0) items = allMedia

    if (items.length === 0) {
      const placeholder = document.createElement('div')
      placeholder.className = 'pdp-carousel__slide'
      placeholder.innerHTML = `
        <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M3 3h18v18H3z" />
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M3 16l5-5 4 4 5-5 4 4" />
        </svg>
        <p>No media available for this product</p>
      `
      track.appendChild(placeholder)
      slideCount = 1
      if (prevBtn) prevBtn.style.display = 'none'
      if (nextBtn) nextBtn.style.display = 'none'
      if (zoomBtn) zoomBtn.hidden = true
      carousel.classList.add('pdp-carousel--no-thumbs')
      return
    }

    // Show/hide arrows based on item count
    const hasMultiple = items.length > 1
    if (prevBtn) prevBtn.style.display = hasMultiple ? '' : 'none'
    if (nextBtn) nextBtn.style.display = hasMultiple ? '' : 'none'

    // Render each item as a slide
    items.forEach((m, i) => {
      const slide = document.createElement('div')
      slide.className = 'pdp-carousel__slide'

      let el
      switch (m.type) {
        case 'image':
          el = document.createElement('img')
          el.src = m.preview_src || m.src
          el.alt = m.alt || ''
          el.loading = i === 0 ? 'eager' : 'lazy'
          if (i === 0) el.fetchPriority = 'high'
          el.width = m.width || 1800
          el.height = m.height || 1800
          // Responsive srcset — Shopify CDN URLs use ?width=X
          if (m.src) {
            var base = m.src.replace(/width=\d+/, '')
            el.srcset = base + 'width=600 600w, ' + base + 'width=900 900w, ' + base + 'width=1200 1200w'
            el.sizes = '(max-width: 768px) 100vw, 60vw'
          }
          el.className = 'photoswipe__image js-photoswipe__zoom'
          el.setAttribute('data-photoswipe-src', m.zoom_src || m.src)
          el.setAttribute('data-photoswipe-width', m.width || 1600)
          el.setAttribute('data-photoswipe-height', m.height || 1600)
          el.setAttribute('data-index', i + 1)
          break
        case 'video':
        case 'external_video':
          el = document.createElement('video')
          el.src = m.src
          el.controls = true
          el.className = 'pdp-carousel__video'
          break
        case 'model':
          el = document.createElement('model-viewer')
          el.src = m.src
          el.setAttribute('ar', '')
          el.setAttribute('camera-controls', '')
          el.className = 'pdp-carousel__model'
          break
      }

      if (el) slide.appendChild(el)
      track.appendChild(slide)
    })

    slideCount = items.length

    // Create dots
    if (hasMultiple) {
      items.forEach((_, i) => {
        const dot = document.createElement('button')
        dot.className = 'pdp-carousel__dot' + (i === 0 ? ' active' : '')
        dot.setAttribute('data-index', i)
        dot.setAttribute('aria-label', 'Go to slide ' + (i + 1))
        dotsContainer.appendChild(dot)
      })
    }

    buildThumbs(items)

    // Size the desktop main column to the first shown image's proportions
    if (items[0].width && items[0].height) {
      carousel.style.setProperty('--pdp-media-ratio', (items[0].width / items[0].height).toFixed(4))
    }

    // Reset to first slide
    track.style.transform = 'translateX(0)'
    if (thumbsList) thumbsList.scrollTop = 0
    syncThumbs()
    syncZoom()

    // PhotoSwipe zoom
    if (!photoswipeInstance && window.theme && window.theme.Photoswipe) {
      photoswipeInstance = new theme.Photoswipe(carousel, 'custom-media', viewerOptions)
    }
  }

  // ────────────────────────────────────────────────
  // Debounced render
  // ────────────────────────────────────────────────
  let debounceTimer
  function debounceRender(color) {
    clearTimeout(debounceTimer)
    debounceTimer = setTimeout(() => renderMedia(color), 50)
  }

  // ────────────────────────────────────────────────
  // Init
  // ────────────────────────────────────────────────
  renderMedia(getSelectedColor())

  document.addEventListener('variant:change', e => {
    const variant = e.detail?.variant
    const color = variant?.option1?.toLowerCase().replace(/\s+/g, '-')
    debounceRender(color)
  })
})